const PAGE_SIZE = 500
const MAX_ROWS = 100000
const COLUMNS = {
  trades: 'id,user_id,symbol,status,account_number',
  executions: 'id,user_id,trade_id,account_number,symbol,execution_type,side,quantity,price,commission,fees,executed_at,order_id,execution_id',
}

async function readSymbolRows(client, table, userId, symbol, signal) {
  const rows = []
  let expected
  do {
    signal?.throwIfAborted()
    const { data, error, count } = await client.from(table)
      .select(COLUMNS[table], { count: 'exact' }).eq('user_id', userId).eq('symbol', symbol)
      .order('id', { ascending: true }).range(rows.length, rows.length + PAGE_SIZE - 1).abortSignal(signal)
    if (error || !Array.isArray(data) || !Number.isInteger(count) || count < 0 || count > MAX_ROWS
      || (expected != null && count !== expected) || (!data.length && rows.length < count)) {
      throw new Error('Execution history could not be loaded completely.')
    }
    expected = count
    rows.push(...data)
  } while (rows.length < expected)
  if (rows.length !== expected || new Set(rows.map(row => row.id)).size !== rows.length
    || rows.some(row => !row.id || row.user_id !== userId || row.symbol !== symbol)) {
    throw new Error('Execution history changed while loading.')
  }
  return rows
}

/** Chart-only history. Never feed these closed fills into sizing or order actions. */
export async function loadChartExecutionHistory(client, userId, symbol, signal) {
  if (!userId || !symbol) throw new Error('An account owner and symbol are required.')
  const [trades, executions] = await Promise.all([
    readSymbolRows(client, 'trades', userId, symbol, signal),
    readSymbolRows(client, 'executions', userId, symbol, signal),
  ])
  const eligible = new Map(trades.filter(trade => trade.status !== 'duplicate').map(trade => [trade.id, trade]))
  return executions.filter(fill => eligible.has(fill.trade_id)
    && eligible.get(fill.trade_id).account_number === fill.account_number)
    .sort((a, b) => String(a.executed_at).localeCompare(String(b.executed_at)) || a.id.localeCompare(b.id))
}
